import {dragHandleSvg as Icon__small__dragHandleSvg} from '../Icon__small/Icon__small--dragHandle.js'

export var dragHandle = {
  name: 'dragHandle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__dragHandleSvg,
};
